import * as React from 'react';
import {
  Button,
  ListGroup,
  ListGroupItem,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
import { object as PropObject } from 'prop-types';

import {
  humanize,
  ScheduledJob,
  Statuses,
  timeoutPromise,
} from '../gs-core/common';

import { ServiceRegistry } from '../services';

interface JobsViewProps {
  onLoading: (loading: boolean) => void;
}

interface JobsViewState {
  jobs: ScheduledJob[];
}

const IN_PROGRESS = Statuses.IN_PROGRESS;

export class JobsView extends React.Component<JobsViewProps, JobsViewState> {
  static contextTypes = { services: PropObject };

  private intervalId: any | null;

  constructor(props: JobsViewProps) {
    super(props);

    this.state = { jobs: [] };
  }

  async componentDidMount() {
    this.props.onLoading(true);

    await this.loadJobs();

    this.props.onLoading(false);

    this.intervalId = setInterval(this.loadJobs, 5000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  loadJobs = async () => {
    const { errorLogger, jobService } = this.context
      .services as ServiceRegistry;

    try {
      const jobs = await jobService.findAll();

      this.setState({ jobs });
    } catch (err) {
      clearInterval(this.intervalId);
      await errorLogger.log(err);
    }
  };

  run = async (job: ScheduledJob) => {
    const { errorLogger, jobService } = this.context
      .services as ServiceRegistry;

    try {
      await jobService.run(job);
    } catch (err) {
      await errorLogger.log(err);
    }

    // Wait 100 ms to allow the job to start
    await timeoutPromise(100);

    await this.loadJobs();
  };

  render() {
    const { jobs } = this.state;

    return (
      <div>
        <div className="row">
          <h2 className="col-xs-12 page-header">Jobs</h2>
        </div>
        <div className="panel panel-body">
          <ListGroup>
            <ListGroupItem className="row hidden-sm">
              <div className="col-md-4">Name</div>
              <div className="col-md-2">Freq</div>
              <div className="col-lg-5 col-md-4">Last Ran</div>
              <div className="col-lg-1 col-md-2">Status</div>
            </ListGroupItem>
            {jobs.map((job) => (
              <ListGroupItem key={job.name} className="row">
                <div className="col-md-4">
                  <Button
                    bsStyle="default"
                    bsSize="small"
                    disabled={job.status === IN_PROGRESS || job.isDisabled()}
                    onClick={() => this.run(job)}
                  >
                    <i
                      className={
                        'fa ' +
                        (job.status === IN_PROGRESS
                          ? 'fa-refresh fa-spin'
                          : 'fa-play')
                      }
                    />
                  </Button>{' '}
                  {job.name}
                </div>
                <div className="col-md-2">{job.cronExpression}</div>
                <div className="col-lg-5 col-md-4">
                  {job.lastRunStartDate &&
                    job.lastRunStartDate.toLocaleDateString()}{' '}
                  {job.lastRunStartDate &&
                    job.lastRunStartDate.toLocaleTimeString()}{' '}
                  -{' '}
                  {job.lastRunEndDate &&
                    job.status !== IN_PROGRESS &&
                    job.lastRunEndDate.toLocaleDateString()}{' '}
                  {job.lastRunEndDate &&
                    job.status !== IN_PROGRESS &&
                    job.lastRunEndDate.toLocaleTimeString()}
                </div>
                <div className="col-lg-1 col-md-2">
                  <OverlayTrigger
                    placement="left"
                    overlay={<Tooltip id={job.name}>{job.error}</Tooltip>}
                  >
                    <span className={'label label-' + job.status}>
                      {humanize(job.status)}
                    </span>
                  </OverlayTrigger>
                </div>
              </ListGroupItem>
            ))}
          </ListGroup>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/JobsView/JobsView.tsx